import { useEffect, useState } from "react";
import Typography from "../../../components/Typography";
import {
  MdOutlineDriveFolderUpload,
  MdOutlineSmsFailed,
  MdPendingActions,
} from "react-icons/md";
import { TiTick } from "react-icons/ti";
import Button from "../../../components/button";
import { EMPTY, PLUS } from "../../../assets";
import {
  CASE_COLUMNS,
  CASE_REGISTRA_COLUMNS,
} from "../../../components/table/columns";
import { selectUser } from "../../../states/slices/authReducer";
import { useAppSelector } from "../../../hooks";
import Api from "../../../config";
import PaginatedTable from "../../../components/table/Paginated-table";
import { getJSONheader } from "../../../utils";

const filterOptions = [
  "ALL",
  "PENDING",
  "ACCEPTED",
  "REJECTED",
  "ON GOING",
  "IN COURT",
  "CONCLUDED",
  "DONE",
  "ASSIGN",
  "REASSIGN",
  "RECALLED",
  "READY FOR HANDLING",
  "FRESH CASE",
  "MENTION",
  "MOTION",
  "PART HEARD",
  "REASSIGNED",
  "SERVED",
  "NOT SERVED",
  "JOIN REQUEST",
  "APPROVED JOIN REQUEST",
];
function MyFiles() {
  const [active, setActive] = useState(0);
  const user = useAppSelector(selectUser);
  const [open, setOpen] = useState(false);
  const [params, setParams] = useState<string>("");
  const [data, setData] = useState([]);
  const [concludedData, setConcludedData] = useState([]);
  const [nonConcludedData, setNonConcludedData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [selected, setSelected] = useState("");
  const [suit_no, setSuitNo] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSelected(selectedValue);
    // onFilterSelect(selectedValue);
  };
  const fetchData = async (page: any, pageSize: any) => {
    setLoading(true);
    try {
      const query = new URLSearchParams();

      if (page !== undefined) {
        query.append("page", page.toString());
      }
      if (suit_no !== "" || suit_no !== undefined) {
        query.append("search", suit_no);
      }
      if (selected && selected !== "ALL") {
        query.append("status", selected);
      }

      const response = await Api.get(
        `/registra2/case-folders?${query}`,
        getJSONheader(),
      );
      const { data, meta } = response.data;
      setLoading(false);
      setData(data);
      setTotalPages(meta.last_page);
      // console.log(data);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const filterDataByStatus = data.filter((item: any) =>
    selected && selected !== "ALL"
      ? item.case_status.status === selected
      : item,
  );
  useEffect(() => {
    fetchData(1, 10);
  }, [selected, suit_no]);

  return (
    <div className="pt-4 px-8 pb-36 lg:pb-0">
      <div className="flex items-center justify-between w-full">
        <Typography textStyle="text-[20px] font-medium">My Files</Typography>
        <div className="w-full max-w-sm flex items-center gap-x-2">
          <label className="block mb-2  text-sm font-medium text-gray-700">
            Search:
          </label>
          <div className="flex w-full items-center gap-2">
            <input
              type="text"
              value={suit_no}
              onChange={(e) => {
                setSuitNo(e.target.value);
                if (e.target.value.trim() === "") {
                  fetchData(1, 10);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData(1, 10);
                }
              }}
              placeholder="Search Suit Number or Name"
              className="block w-full outline-none p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
            <button
              onClick={() => fetchData(1, 10)}
              className="px-4 py-2.5 bg-[#272755] text-white text-sm font-medium rounded-lg hover:bg-opacity-90 transition-all"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="w-full  pb-20 lg:pb-0">
        <div className="w-full flex flex-row justify-between items-start pl-5 pt-4 lg:pt-0">
          {/* <div className="flex justify-between items-center w-[70%]">
            <div
              onClick={() => setActive(0)}
              className={` flex  w-full items-center py-2 px-3 cursor-pointer ${
                active === 0 ? " text-brand_blue font-medium" : ""
              }`}
            >
              <MdOutlineDriveFolderUpload className="h-5  mr-4" />
              <span className="font-400 text-[16px] md:text-[14px] md:leading-[22px]">
                All files {`(${data?.length})`}
              </span>
            </div>
            <div
              onClick={() => {
                setActive(1);
                setParams("PENDING");
              }}
              className={` flex  w-full items-center py-2 px-3 cursor-pointer  ${
                active === 1 ? " text-brand_blue font-medium" : ""
              }`}
            >
              <TiTick className="h-5  mr-4" />
              <span className="font-400 text-[16px] md:text-[14px] md:leading-[22px]">
                Concluded {`(${concludedData?.length})`}
              </span>
            </div>
            <div
              onClick={() => {
                setActive(2);
                setParams("IN COURT");
              }}
              className={` flex  w-full items-center py-2 px-3 cursor-pointer ${
                active === 2 ? " text-brand_blue font-medium" : ""
              }`}
            >
              <TiTick className="h-5  mr-4" />
              <span className="font-400 text-[16px] md:text-[14px] md:leading-[22px]">
                Non Concluded {`(${nonConcludedData?.length})`}
              </span>
            </div>
          </div> */}
          <div className="w-full mt-7 max-w-xs flex items-center gap-x-2">
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Filter:
            </label>

            <select
              value={selected}
              onChange={handleChange}
              className="block w-full outline-none p-2.5 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" disabled>
                Select a status
              </option>
              {filterOptions.map((option) => (
                <option key={option} value={option}>
                  {option.toLowerCase().replace(/_/g, " ")}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-8 lg:flex">
          <div className=" w-full lg:mb-0">
            <div className=" border-b  border-[#F0F0F0] rounded-b-xl">
              <PaginatedTable
                columns={CASE_REGISTRA_COLUMNS}
                data={filterDataByStatus}
                totalPages={totalPages}
                fetchData={fetchData}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyFiles;
